<template>
<div class="page">
    <div class="loading-screen" v-if="status=='LOADING'">
        <div>
            <span class="spinner spinner--lg"></span>
            <span>loading questions…</span>
        </div>
    </div>

    <div v-if="status=='LOADED'">
        <ExaminerNavBar/>
        <div class="container">
            <div class="page-head rise">
                <h1>Question Bank</h1>
                <p>Every question available for assessments, with formats and test cases.</p>
            </div>

            <div v-if="questions.length==0" class="glass empty-state rise">
                <div class="empty-state__icon">🗃️</div>
                <h2>No questions yet</h2>
                <p>Add a question to start building assessments.</p>
                <a class="btn btn--primary" href="/addquestion">＋ New Question</a>
            </div>

            <div v-for="(question, index) in questions" :key="question._id"
                 class="glass card card--hover mb-3 rise" :class="`rise-${Math.min(index+1,4)}`">
                <span class="card__meta">question {{String(index+1).padStart(2,'0')}}</span>
                <h2 class="card__title mt-2">
                    {{question.name}}
                    <span class="badge badge--easy" v-if="question.difficulty=='easy'">easy</span>
                    <span class="badge badge--medium" v-else-if="question.difficulty=='medium'">medium</span>
                    <span class="badge badge--hard" v-else>hard</span>
                </h2>
                <p class="text-dim mt-2" style="font-size:0.92rem">{{question.statement}}</p>

                <div v-if="question.view" class="mt-3">
                    <div class="section-block">
                        <div class="section-block__head">Input Format</div>
                        <div class="section-block__body">
                            <ul>
                                <li v-for="(inputType, i) in question.inputFormat.type" :key="i">
                                    <span class="mono" style="color:var(--accent)">{{question.inputFormat.type[i]}}</span> — {{question.inputFormat.description[i]}}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="section-block">
                        <div class="section-block__head">Output Format</div>
                        <div class="section-block__body">
                            <span class="mono" style="color:var(--accent)">{{question.outputFormat.type}}</span> — {{question.outputFormat.description}}
                        </div>
                    </div>
                    <div class="section-block">
                        <div class="section-block__head">Constraints</div>
                        <div class="section-block__body">
                            <ul>
                                <li v-for="(constraint, i) in question.constraints" :key="i" class="mono" style="font-size:0.85rem">{{constraint}}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="section-block">
                        <div class="section-block__head">Sample Test Cases</div>
                        <div class="section-block__body">
                            <ul>
                                <li v-for="(input, i) in question.sampleTestCases.input" :key="i">
                                    <span class="mono"><strong>in:</strong> {{question.sampleTestCases.input[i]}} → <strong>out:</strong> {{question.sampleTestCases.output[i]}}</span>
                                    <div class="text-dim" style="font-size:0.85rem">{{question.sampleTestCases.explanation[i]}}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="section-block">
                        <div class="section-block__head">Hidden Test Cases</div>
                        <div class="section-block__body">
                            <ul>
                                <li v-for="(input, i) in question.testCases.input" :key="i" class="mono" style="font-size:0.85rem">
                                    <strong>in:</strong> {{question.testCases.input[i].replace(/[{}]/gi,"")}} → <strong>expected:</strong> {{question.testCases.expectedOutput.replace(/[{}]/gi,"").split(",")[i]}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="flex gap-2 mt-3">
                    <button class="btn btn--ghost btn--sm" @click="viewQuestion(index)">{{question.view ? 'Hide details' : 'View details'}}</button>
                    <button class="btn btn--danger btn--sm" @click="deleteQuestion(question._id)"
                            :disabled="deleteStatus.status=='LOADING' && deleteStatus.id == question._id">
                        <span class="spinner" v-if="deleteStatus.status=='LOADING' && deleteStatus.id == question._id"></span>
                        <span v-else>Delete</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {getAllQuestions, deleteQuestion} from '../services/questions'
import ExaminerNavBar from './ExaminerNavBar.vue';
import Vue from 'vue';

export default {
    name: "AllQuestionsPage",
    data() {
        return {
            status: "LOADING",
            deleteStatus: {
                id: '',
                status: ''
            },
            error: "",
            questions: [],
            assesmentId: "",
            toggleQuestionsView: []
        };
    },
    methods: {
        async getAllQuestions() {
            try {
                const response = await getAllQuestions();
                this.questions = response.data;
                for (let question in this.questions) {
                    this.questions[question] = {
                    ...this.questions[question],
                    view : false
                }
                }

                this.status = "LOADED";
            }
            catch (error) {
                this.status = "ERROR";
                this.error = error.message;
            }
        },
        async deleteQuestion(questionId) {
            try{
                    this.deleteStatus.id = questionId;
                    this.deleteStatus.status = 'LOADING'
                    const response = await deleteQuestion(questionId);
                    Vue.$toast.success('Question - '+response.data.name +' Deleted Successfully');

                } catch(error){
                    Vue.$toast.error(error.message);
                }
                this.deleteStatus.status = 'LOADED';
            await this.getAllQuestions();
        },
        viewQuestion(index) {
            this.$set(this.questions, index, { ...this.questions[index], view: !this.questions[index].view });
        }
    },
    async created() {
        await this.getAllQuestions();
    },
    components: {
    ExaminerNavBar }
}
</script>
